import { Action, Alert, Modal } from 'corso-admin-ui';
import { useState } from 'react';
import {
  useClaim,
  useIsLocked,
} from '~/features/claimReview/ClaimReviewProvider';
import { useClaimOrderLineage } from '~/features/claimReview/hooks/useClaimOrderLineage';
import { ClaimLineageHistory } from './summary/ClaimOrderLineage';

/** Where a credit's value comes from for an exchange of an exchange, and the way into the full chain. */
export function ClaimLineageAlert() {
  const [show, setShow] = useState(false);
  const isLocked = useIsLocked();
  const { requestSummary } = useClaim();
  const { data: lineage } = useClaimOrderLineage();

  // a credit absorbed by Shop Now or zeroed by fees never reaches the originating order
  const hasRefund = (requestSummary?.totals.refund ?? 0) > 0;
  const hasGiftCard = (requestSummary?.totals.giftCard ?? 0) > 0;

  // ? lineage has to have hops to be useful.
  if (!lineage?.hops.length || isLocked || (!hasRefund && !hasGiftCard))
    return null;

  const order =
    lineage.originalOrder.nameFromPlatform ??
    lineage.originalOrder.orderNumber ??
    `OrderId ${lineage.originalOrder.id}`;

  const viewLineage = (
    <Action variant="link" onClick={() => setShow(true)}>
      View claim lineage
    </Action>
  );

  const orderLink = (
    <Action
      to={lineage.originalOrder.platformAdminUrl}
      target="_blank"
      variant="link"
    >
      {order}
    </Action>
  );

  return (
    <div className="mb-2 space-y-2">
      {hasRefund && (
        <Alert elevated variant="warning" heading="Originating Order Refund">
          <div>
            Refunds will be attempted against original order {orderLink}.{' '}
            {viewLineage}
          </div>
        </Alert>
      )}
      {hasGiftCard && (
        <Alert elevated variant="warning" heading="Originating Order Gift Card">
          {`Gift Card values are set by the amount originally paid on order ${order}.`}{' '}
          {viewLineage}
        </Alert>
      )}
      <Modal
        title="Claim lineage"
        show={show}
        onClose={() => setShow(false)}
        size="lg"
      >
        <ClaimLineageHistory lineage={lineage} />
      </Modal>
    </div>
  );
}
